'use client';
export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  return (
    <div className="min-h-[100dvh] flex flex-col items-center justify-center bg-dark-bg text-dark-text px-4">
      <p className="text-error text-sm font-semibold tracking-wider uppercase mb-4">Something went wrong</p>
      <h2 className="text-3xl font-bold text-dark-text mb-3 tracking-tight">An error occurred</h2>
      <p className="text-dark-muted mb-8 text-center max-w-md">{error.message || 'An unexpected error occurred. Please try again.'}</p>
      <button
        onClick={reset}
        className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 active:bg-primary-700 text-white px-6 py-3 rounded-full font-semibold transition-all duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 focus-visible:ring-offset-dark-bg"
      >
        Try again
      </button>
    </div>
  );
}
